import React from "react";
import { Chip, Divider, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import { HubIcon, UserDetailIcon } from "../../components";
import { getDollarValue } from "../../helpers/currency";
import { QUOTE_STAGE_LABELS } from "../../constants/salesStages";

import SalesContextMenu from "./SalesContextMenu";
import { StyledCard } from "./styles";

const QuoteCard = ({
  id,
  quoteNumber,
  part,
  partName,
  partNumber,
  total,
  customer,
  stage,
  createdBy,
  createdAt,
}) => {
  const navigate = useNavigate();

  const name = part?.partName || partName || "Unnamed Part";
  const number = part?.partNumber || partNumber;
  const customerName = customer?.name;
  const stageInfo = QUOTE_STAGE_LABELS.find((s) => s.id === stage);

  const onClick = () => quoteNumber && navigate(`/quotes/${quoteNumber}`);

  return (
    <StyledCard onClick={onClick}>
      <Stack direction="row" justifyContent="space-between" alignItems="start">
        <Stack overflow="hidden">
          <Typography variant="boldCaptionL" fontSize={14} noWrap>
            {name}
          </Typography>
          <Typography variant="caption11" noWrap>
            {number}
          </Typography>
        </Stack>
        <SalesContextMenu itemId={id} onEdit={onClick} type="quote" />
      </Stack>

      <Stack direction="row" gap="6px" alignItems="center">
        {total && (
          <Typography variant="caption11">{getDollarValue(total)}</Typography>
        )}
        {total && quoteNumber && (
          <Typography
            variant="caption"
            lineHeight="12px"
            fontSize={24}
            color="text.disabled"
          >
            •
          </Typography>
        )}
        {quoteNumber && (
          <Stack direction="row" gap="4px" alignItems="center">
            <HubIcon icon="FileText" size={11} />
            <Typography variant="caption11">{quoteNumber}</Typography>
          </Stack>
        )}
      </Stack>

      {(customerName || createdAt) && (
        <Stack direction="row" gap="6px" alignItems="center" flexWrap="wrap">
          {customerName && (
            <Stack direction="row" gap="4px" alignItems="center">
              <HubIcon icon="User" size={11} />
              <Typography variant="caption11" noWrap>
                {customerName}
              </Typography>
            </Stack>
          )}
          {customerName && createdAt && (
            <Typography
              variant="caption"
              lineHeight="12px"
              fontSize={24}
              color="text.disabled"
            >
              •
            </Typography>
          )}
          {createdAt && (
            <Stack direction="row" gap="4px" alignItems="center">
              <HubIcon icon="Calendar" size={11} />
              <Typography variant="caption11">
                {dayjs(createdAt).format("MMM D, YYYY")}
              </Typography>
            </Stack>
          )}
        </Stack>
      )}

      <Divider />

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {createdBy ? (
          <UserDetailIcon
            size={18}
            user={{ name: createdBy.name, hueShift: createdBy.id }}
            variant="rounded"
            includeName={createdBy.name}
          />
        ) : (
          <Typography variant="caption" fontSize={10} color="text.disabled">
            No Creator
          </Typography>
        )}
        {stageInfo && (
          <Chip
            variant="colorTag"
            flow={stageInfo.flow}
            label={stageInfo.label}
            size="small"
            sx={{ fontSize: 10 }}
          />
        )}
      </Stack>
    </StyledCard>
  );
};

export default QuoteCard;
